<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-three-fifths is-offset-one-fifth">
            <iframe
              scrolling="no"
              id="frame-act"
              width="100%"
              :src="iframeSrc"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ActivationCompte',
  computed: {
    iframeSrc: function () {
      let urlReturn = ''
      if (
        this.$route.params.id !== undefined &&
        this.$route.params.token !== undefined
      ) {
        urlReturn =
          '/accounts/activate_account/' +
          this.$route.params.id +
          '/' +
          this.$route.params.token +
          '/'
      }
      return urlReturn
    }
  }
}
</script>

<style lang="css">
#frame-act {
  height: 150px !important;
}
</style>
